<template>
  <div :class="`LinksPre ${style.bg_gradient} ${editing?'editing':''}`" :style="`background:${style.bg_color}`">
    
    <div class="middle-container">
      <div>
        <ImageLoader v-if="loadingImage" />
        <MainImage
        :borderColor='style.bt_color'
        :srcImage="srcImage"
        :borderSize='style.img_border'
      />
      </div>
      <ButtonLoader v-if="loadingLinks"/>
      <link-button 
        v-for="red in links" v-bind:key="red.link" 
        :icon='red.icon'
        :name='red.name'
        :url='red.url'
        :fill='style.bt_fill'
        :bt_shape="style.bt_shape"
        :mainColor='style.bt_color'
        :secondaryColor="style.bt_text_color"
      />
      <Watermark/>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Watermark from '@/components/Watermark.vue'
import ButtonLoader from '@/components/loaders/ButtonLoader.vue'
import ImageLoader from '@/components/loaders/ImageLoader.vue'
import LinkButton from '@/components/LinkButton.vue'
import MainImage from '@/components/MainImage.vue'
export default {
  components: { 
    LinkButton,
    MainImage,
    Watermark,
    ButtonLoader,
    ImageLoader
  },
  name: 'LinksPre',
  props:{
    editing:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    ...mapGetters(['links',"style",'srcImage','loadingLinks','loadingImage'])
  },
  
}
</script>

<style scoped lang="scss">
//default layout 
.LinksPre{
  width:100%;
  min-height: 100%;
  padding: 2%;
  display: flex;
  background-image: url("../assets/BackgroundTextures/zigzag.svg") !important;

}
.zebra_bg{
  background-image: url("../assets/BackgroundTextures/zigzag.svg") !important;
}
.middle-container{
  margin: auto;
  width: inherit;
  max-width: 500px;
  transition: margin 0.5s max-height 0.5s;
}
.editing{
  .middle-container{
    max-height: 50vh ;
    margin-top: 0;
  }
}
.scroll{
  background: transparent;
  height: 64%;
  overflow-y: auto;
}
.round{
  border-radius: 50000px;
}

</style>

